export const initialTasterData = {
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  gender: null,
  dateOfBirth: "",
  education: null,
  smoking: null,
};

export const genderSelectOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

export const educationSelectOptions = [
  { value: "middle-school", label: "Middle school" },
  { value: "high-school", label: "High school" },
  { value: "under-graduate", label: "Undergraduate degree" },
  { value: "graduate", label: "Graduate degree" },
  { value: "post-graduate", label: "Post-graduate degree" },
  { value: "other", label: "Other" },
];

export const smokingSelectOptions = [
  { value: "yes", label: "Smoker" },
  { value: "no", label: "Non-smoker" },
  { value: "ex-smoker", label: "Ex-smoker" },
];
